// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/less/style.less
// module id = n8o6
// module chunks = 47